import React, { useEffect, useState } from "react";
import "./home.css";
import SemiRealGallery from "./components/images-slider/semireal-gallery";
import YouTubeAutoPlay from "./components/youtube-auto-play";
import ButtonRow from "./components/button-row";
import { Helmet } from "react-helmet";
import BaseGallery from "./components/images-slider/base-gallery";
import AdoptableGallery from "./components/images-slider/adoptable-gallery";
import YchGallery from "./components/images-slider/ych-gallery";
import CharSheetGallery from "./components/images-slider/char-sheet-gallery";
import HeadshotGallery from "./components/images-slider/headshot-gallery";
import CustomGallery from "./components/images-slider/custom-gallery ";

function Home() {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setImageLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="home-container">
      <Helmet>
        <title>✧･ﾟhome･ﾟ:*</title>
      </Helmet>
      {/* ส่วนของรูปภาพและข้อความ */}
      <div className="image-section">
        <img
          className={`home-image ${imageLoaded ? "fade-in" : ""}`}
          src="https://img5.pic.in.th/file/secure-sv1/-1058_20230623151426-1.png"
          alt="ไม่มีชื่อ 1058 20230623151426 (1)"
        />

        <h1 className="home-title">M I L D M I S A K I</h1>
      </div>
      <div>
        <ButtonRow />
      </div>
      <div className="gallery-section">
        <HeadshotGallery />
      </div>
      <div className="gallery-section">
        <AdoptableGallery />
      </div>
      <div className="gallery-section">
        <CustomGallery />
      </div>
      <div className="gallery-section">
        <CharSheetGallery />
      </div>
      <div className="gallery-section">
        <SemiRealGallery />
      </div>
      <div className="gallery-section">
        <YchGallery />
      </div>
      <div className="gallery-section">
        <BaseGallery />
      </div>
    </div>
  );
}

export default Home;
